import styled, { css } from 'styled-components';

import { Grid } from '@powdr/components';
import {
  ThemeProps as Prop, Components, Breakpoints,
} from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

const CPNT = Components.PRODUCT_FINDER;

export const Header = styled.header`
  margin-bottom: 25px;
  border-bottom: 1px solid ${({ $colorProfile }) => themeUtil(Prop.BORDER, CPNT, $colorProfile)};

  h3 {
    ${({ theme }) => theme.fonts.PRI_HDR_BLK};
    font-size: ${({ theme }) => theme.FontSize.LRG10};
  }

  p {
    ${({ theme }) => theme.fonts.PRI_BDY_MED};
    font-size: ${({ theme }) => theme.FontSize.REG20};
  }

  h3, p {
    margin-bottom: 15px;
  }
`;

export const ItemsContainer = styled.div``;

export const StyledLayoutMain = styled.div`
  flex: 1 1 auto;
  position: relative;
  z-index: 1;
`;

export const StyledLayoutAside = styled.div`
  ${({ $horizontalFilter, $stickyPosition }) => (
    (!$horizontalFilter)
      ? `flex: 0 0 225px; position: sticky; top: ${$stickyPosition}px; overflow-y: auto; height: calc(100vh - ${$stickyPosition}px - 20px);`
      : 'height: 100%;'
  )};
  margin-bottom: 20px;
`;

export const StyledGrid = styled(Grid)`
  margin: 0;
`;

export const FilterTags = styled.ul`
  display: flex;
  gap: 15px;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
`;

export const FilterTag = styled.li`
  button.btn {
    display: flex;
    align-items: center;
    padding: 10px;
    color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, colorProfile)};
    background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, colorProfile)};
    transition: color 0.25s ease-out, background-color 0.25s ease-out;

    &:hover, &:focus {
      transition: color 0.25s ease-out, background-color 0.25s ease-out;
      color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, colorProfile)};
      background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, colorProfile)};
    }

    &:active {
      color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, colorProfile)};
      background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, colorProfile)};
    }

    &:focus {
      outline: 2px solid ${({ colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, colorProfile)};
      outline-offset: 2px;
    }
  }

  .icon {
    margin-left: 5px;

    svg {
      fill: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, colorProfile)};
      color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, colorProfile)};
    }
  }
`;

export const StyledLayoutRow = styled.div`
  display: flex;
  flex-direction: ${({ $horizontalFilter }) => (($horizontalFilter) ? 'column' : 'row')};
  gap: 50px;

  ${Breakpoints.mobile(css`
    display: block;
  `)}
`;

export const StyledDrawer = styled.div`
  position: sticky;
  top: ${({ top }) => `${top}px`};
  z-index: 70;

  button.btn-clear {
    font-size: ${({ theme }) => theme.FontSize.REG30};
    margin-top: 15px;
    transition: color 0.25s ease-out, background-color 0.25s ease-out;
    margin-left: 25px;
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};

    &:hover {
      color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)} ;
      background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    }

    &:active {
      background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, $colorProfile)};
      background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, $colorProfile)};
    }
  }

  .ui-drawer {
    height: 100%;

    .drawer {
      padding: 0;
      background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};

      button.fixed-open {
        position: absolute;
        right: 0;
        top: 50px;
        width: 130px;

        &.an-open {
          right: -130px;
        }
      }
    }
  }


  .btn-clear {
    color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, colorProfile)};
    background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, colorProfile)};

    &:hover, &:focus {
      transition: color 0.25s ease-out, background-color 0.25s ease-out;
      color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, colorProfile)};
      background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, colorProfile)};
    }

    &:focus {
      outline: 2px solid ${({ colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, colorProfile)};
      outline-offset: 2px;
    }
  }

  .ui-drawer-enabled {
    width: 310px;
  }

  .ui-drawer-content-wrap {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};
  }

  .ui-drawer-content {
    max-height: ${(props) => `calc(100vh - ${parseFloat(props.top) + 35}px)`} ;
    overflow-x: hidden;
    padding-top: 15px;
  }

  .ui-drawer-btn-toggle {
    ${({ theme }) => theme.fonts.PRI_HDR_BLK};
    background-color: ${({ $drawerButtonColor }) => themeUtil(Prop.BTN_BG, CPNT, $drawerButtonColor)};
    color: ${({ $drawerButtonColor }) => themeUtil(Prop.BTN_TXT, CPNT, $drawerButtonColor)};
    position: absolute;
    left: 100%;
    padding: 15px;
    transform-origin: bottom left;
    transform: rotate(90deg);
    font-size: 24px;
    line-height: 30px;

    &:hover {
      color: ${({ $drawerButtonColor }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $drawerButtonColor)} ;
      background-color: ${({ $drawerButtonColor }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $drawerButtonColor)};
    }

    &:active {
      background-color: ${({ $drawerButtonColor }) => themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, $drawerButtonColor)};
      background-color: ${({ $drawerButtonColor }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, $drawerButtonColor)};
    }
  }
`;
